import colors from '../gatsby-plugin-theme-ui/colors';

export const useColors = (darkMode) => {
  const { hiContrast, lowContrast } = darkMode ? colors.modes.dark : colors;
  return { hiContrast, lowContrast };
};
